export default __webpack_public_path__ + "fonts/142e8dc60437fe712928d332dc50ae0d.woff";